import React from 'react'
import NavBar from "../Components/Navbar"
import Footer from '../Components/Footer'
import HeroImgForPages from '../Components/HeroImgForPages'
import AboutContent from '../Components/AboutContent'
function About() {
  return (
    <div>
       <NavBar />
      <HeroImgForPages heading="ABOUT" text="Im a Jr. Front-End Web Developer" />
      <AboutContent />
      <Footer />
    </div>
  )
}

export default About